import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EntityService } from '@services/core/entity.service';
import { EditEntityComponent } from './editEntity/edit_entity.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-entities',
	templateUrl: './entities.component.html',
	styleUrls: ["./entities.component.css"],
    imports: [CommonModule, PanelComponent, EditEntityComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class EntitiesComponent implements OnInit{
    protected entities
    protected entity
    private entitiesTemp
    protected showEditEntity = false
    private entityService = inject(EntityService)
    private destroyRef = inject(DestroyRef)
    protected auditors
	

	ngOnInit(): void {
	    this.getEntities()
	    this.getAuditors()
	}
    
    getEntities(){
        this.entity = null
        this.showEditEntity = false
        this.entityService.getEntities().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.entities = res
            this.entitiesTemp = res
        })
    }

    getAuditors(){
        this.entityService.getAuditors().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.auditors = res
        })
    }



    private matchEntity(entity: any, valor: string): boolean {
        const q = valor.toLowerCase()
        return entity.name.toLowerCase().includes(q)
            || entity.code.toString().includes(q)
            || entity.group?.name.toLowerCase().includes(q)
            || entity.office?.acronym.toLowerCase().includes(q)
            || entity.auditor?.displayName.toLowerCase().includes(q)
    }

    filterEntities(valor: string) {
        this.entities = valor.length >= 3
            ? this.entitiesTemp.filter(e => this.matchEntity(e, valor))
            : this.entitiesTemp
    }

    addEntity(){
        this.entity = null
        this.showEditEntity = true
    }

    setEditEntity(entity: any){
        this.entity = entity
    }

    activeDeactiveEntity(entity: any){
        entity.enabled = !entity.enabled
        this.entityService.updateEntity(entity).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.getEntities()
        })
    }
}
